
import { computed, defineComponent, onBeforeMount, onMounted, reactive, ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'

import Loader from '@/common/components/UI/Loader/index.vue'

import OkTabs from '@/modules/OktellModule/components/OkTabs/index.vue'
import OkButton from '@/modules/OktellModule/components/OkButton/index.vue'
import OkSelect from '@/modules/OktellModule/components/OkSelect/index.vue'
import OkInput from '@/modules/OktellModule/components/OkInput/index.vue'
import OkTable from '@/modules/OktellModule/components/OkTable/index.vue'
import OkCheap from '@/modules/OktellModule/components/OkCheap/index.vue'
import OkWaitList from '@/modules/OktellModule/components/OkWaitList/index.vue'
// import OkAudioRecord from '@/modules/OktellModule/components/OkAudioRecord/index.vue'
// import OkAudioRecordMini from '@/modules/OktellModule/components/OkAudioRecordMini/index.vue'
import OkModal from '@/modules/OktellModule/components/OkModal/index.vue'

const TABS = [
    { id: 1, name: 'История заказов' },
    { id: 2, name: 'История коммуникаций' },
]

import { useOktellStore } from '@/modules/OktellModule/store/useOktellStore'

import { oktell } from '@/core/realisations/oktell.realisation'

import { OktellClient, OktellInvoice, OktellInvoiceStatus } from '@/core/types/oktell.types'

import useNotifications from '@/common/composable/useNotifications'
import { useDebounce } from 'vue-composable'

import { formatStringDate } from '@/modules/OktellModule/utils/date.util'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import takeAPI from '@/new-services/takes.service'
import { orders } from '@/core/realisations/orders.realisation'
import { DataState } from '@/core/classes/DataState.class'
import { PeriodT } from '@/core/types/companies.types'

const TABLE_COLUMNS = [
    {
        name: '№ заказа',
        key: 'orderNumber',
    },
    {
        name: 'Наименование',
        key: 'productName',
    },
    {
        name: 'Номер накладной',
        key: 'invoiceNumber',
    },
    {
        name: 'Дата оформления',
        key: 'createdAt',
    },
    {
        name: 'Дата доставки',
        key: 'deliveryAt',
    },
    {
        name: 'Тип клиента',
        key: 'clientTypeDescription',
    },
    {
        name: 'Кто оплачивает',
        key: 'payerTypeDescription',
    },
    {
        name: 'Статус доставки',
        key: 'statusName',
    },
    {
        name: 'Оплата',
        key: 'isPaid',
    },
    {
        name: 'Еще',
        key: 'actions',
    },
]

export default defineComponent({
    components: {
        OkTabs,
        Loader,
        OkButton,
        OkSelect,
        OkInput,
        OkTable,
        OkCheap,
        OkWaitList,
        OkModal,
    },
    setup() {
        const router = useRouter()
        const route = useRoute()
        const store = useOktellStore()
        const notifications = useNotifications()

        const currentTab = ref(TABS[0].id)

        const state = reactive({
            is_loading: false,
            is_failed: false,
            orders: [] as OktellInvoice[],
            filters: {
                statusId: null as number | null,
                search: null as string | null,
            },
        })

        const data_state = reactive({
            periods: new DataState<PeriodT>({}),
        })

        const state_date = reactive({
            is_open: false,
            is_loading: false,
            //
            newDate: null as string | null,
            orderId: null as number | null,
            periodId: null as number | null,
        })

        const state_date_form$ = useVuelidate(
            {
                newDate: { required },
                periodId: { required },
            },
            state_date
        )

        const orderStatuses = reactive({
            is_loading: false,
            is_failed: false,
            list: [] as OktellInvoiceStatus[],
        })

        //

        const onTabChange = () => {
            router.push({ path: `/oktell/clients/communications`, query: route.query })
        }

        const loadOrderStatuses = async () => {
            try {
                orderStatuses.is_loading = true

                const response = await oktell.getInvoiceStatuses()
                orderStatuses.list = response.data

                orderStatuses.is_failed = false
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При загрузке статусов произошла ошибка',
                })
                orderStatuses.is_failed = true
            } finally {
                orderStatuses.is_loading = false
            }
        }

        const loadOrders = async () => {
            try {
                state.is_loading = true

                const response = await oktell.getInvoices({
                    page: 1,
                    limit: 9999,
                    customerId: (store.client as OktellClient).id,
                    statusId: state.filters.statusId,
                    search: state.filters.search,
                })

                state.orders = response.data

                state.is_failed = false
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При загрузке истории накладных произошла ошибка',
                })

                console.error(error)
                state.is_failed = true
            } finally {
                state.is_loading = false
            }
        }

        const debouncedSearch = useDebounce(loadOrders, 1000)

        const onRowClick = (row: any) => {
            router.push({
                path: `/oktell/clients/invoices/${row.id}`,
                query: route.query,
            })
        }

        const onDateChanged = (value: string) => {
            state_date.newDate = value
        }

        const openDate = (item: OktellInvoice) => {
            state_date.orderId = item.orderId
            state_date.is_open = true
        }

        const closeDate = () => {
            state_date.is_open = false
            state_date.orderId = null
            state_date.periodId = null
            state_date.newDate = null
        }

        const confirmDate = async () => {
            state_date_form$.value.$touch()
            if (!state_date.newDate || !state_date.periodId || !state_date.orderId) {
                return
            }

            try {
                state_date.is_loading = true

                const payload = {
                    orderId: state_date.orderId,
                    newDate: state_date.newDate as string,
                    periodId: state_date.periodId,
                }
                await takeAPI.changeOrderTakeDate(payload)

                notifications.notify({ title: 'Дата успешно перенесена!', type: 'success' })
                closeDate()
                loadOrders()
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При переносе даты произошла ошибка',
                })
            } finally {
                state_date.is_loading = false
            }
        }

        const loadPeriods = async () => {
            data_state.periods.pagination.current_page = 1

            try {
                data_state.periods.is_loading = true
                const response = await orders.getPeriods()
                data_state.periods.list = response.data

                data_state.periods.pagination.total_pages = 1

                data_state.periods.is_failed = false
                data_state.periods.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.periods.failure.catchError(error)

                if (!data_state.periods.failure.error_state.is_cancel) {
                    data_state.periods.is_failed = true
                }
            } finally {
                if (!data_state.periods.failure.error_state.is_cancel) {
                    data_state.periods.is_loading = false
                }
            }
        }

        // computed

        const deliveredInvoices = computed(() => {
            return state.orders.filter((order) => order.statusId === 10)
        })
        const cancelledInvoices = computed(() => {
            return state.orders.filter((order) => order.statusId === 51)
        })

        // watch

        watch(
            () => store.client,
            (newVal) => {
                if (newVal) {
                    loadOrders()
                }
            }
        )

        // hooks

        onBeforeMount(loadOrderStatuses)

        onMounted(() => {
            loadPeriods()
            if (store.client) {
                loadOrders()
            }
        })

        //

        return {
            state,
            state_date,
            state_date_form$,
            data_state,
            //
            orderStatuses,
            currentTab,
            //
            onTabChange,
            loadOrders,
            loadOrderStatuses,
            onRowClick,
            formatStringDate,
            debouncedSearch,
            openDate,
            onDateChanged,
            confirmDate,
            closeDate,
            loadPeriods,
            //
            deliveredInvoices,
            cancelledInvoices,
            //
            TABS,
            TABLE_COLUMNS,
        }
    },
})
